import React from 'react'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import localization from './localization'
import mergeStyles from '@web/helpers/mergeStyles'
import withLocalization from '@web/helpers/localizationUtils'

const NoDataAvailableBar = ({ style, name, t }) => {
  const { theme } = useTheme()
  const defaultStyle = themeStyles(theme)
  const styles = mergeStyles(defaultStyle, style)
  return (
    <div style={styles.container}>
        {name ? `${t('noData')} ${t(name)}` : t('noDataAvailable')}
    </div>
  )
}

export default withLocalization(NoDataAvailableBar, localization)
